import { Box, BoxOwnProps, Text } from "@sembark-travel/ui-base"
import { useMemo } from "react"
import { getColorForString } from "generate-colors"

// Initials avatar for a WhatsApp contact — reused in the thread list, the
// conversation header and the context pane.
export function WhatsAppContactAvatar({
	name,
	number,
	size = "10",
}: {
	name?: string | null
	number?: string | null
	size?: BoxOwnProps["size"]
}) {
	const source = (name || number || "?").trim()
	const tokens = source.split(/[\s_.@-]+/).filter(Boolean)
	if (tokens.length === 1 && source.length > 1) {
		tokens.push(source.slice(1)[0])
	}
	const initials =
		tokens.length > 1
			? tokens
					.map((t) => t.match(/[A-Za-z0-9]/)?.[0] || "")
					.filter(Boolean)
					.slice(0, 2)
					.join("")
					.toUpperCase()
			: "?"
	const [bgColor, borderColor, textColor] = useMemo(() => {
		return [
			`rgba(${getColorForString(source, {
				contrast: 90,
			}).join(",")}, .2)`,
			`rgba(${getColorForString(source, {
				contrast: 90,
			}).join(",")}, .5)`,
			`rgba(${getColorForString(source, {
				contrast: 50,
			}).join(",")}, 1)`,
		]
	}, [source])
	return (
		<Box
			width={size}
			height={size}
			rounded="full"
			borderWidth="1"
			display="flex"
			alignItems="center"
			justifyContent="center"
			flexShrink="0"
			style={{
				backgroundColor: bgColor,
				borderColor: borderColor,
			}}
		>
			<Text fontWeight="semibold" fontSize="sm" style={{ color: textColor }}>
				{initials || "?"}
			</Text>
		</Box>
	)
}
